<template>
  <div>
    <!-- Header: Personal Info -->
    <div class="d-flex">
      <h4 class="mb-0">Basic Information</h4>
    </div>

    <!-- Form: Personal Info Form -->
    <b-form class="mt-1">
      <!-- Form: Personal Info Form -->
      <b-row class="mt-1">
        <!-- Field: Course Name -->
        <b-col cols="12" lg="4" md="6" xs="12">
          <b-form-group label="Name" label-for="course-name">
            <b-form-input id="course-name" required v-model="courseDataInfo.name" />
          </b-form-group>
        </b-col>

        <!-- Field: Visibility -->
        <b-col cols="12" lg="4" md="6" xs="12">
          <b-form-group label="Visibility" label-for="course-visibility">
            <v-select
              v-model="courseDataInfo.visibility"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="visibilityOptions"
              :clearable="false"
              required
              input-id="course-visibility"
            />
          </b-form-group>
        </b-col>

        <!-- Field: Status -->
        <b-col cols="12" lg="4" md="6" xs="12">
          <b-form-group label="Status" label-for="course-status">
            <v-select
              v-model="courseDataInfo.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              :clearable="false"
              required
              input-id="course-status"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2 w-100">
        <b-col cols="12" lg="12">
          <b-button
            variant="primary"
            class="float-right"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="doSaveChanges"
          >
            Save Changes
          </b-button>
          <b-button
            variant="outline-secondary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1 float-right"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="$router.back()"
          >
            <feather-icon icon="ArrowLeftIcon" />
            Return
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton } from 'bootstrap-vue';
import flatPickr from 'vue-flatpickr-component';
import { onUnmounted, ref } from '@vue/composition-api';
import vSelect from 'vue-select';
import store from '@/store';
import rosterStoreModule from '@/views/apps/roster/rosterStoreModule';
import router from '@/router';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import useCoursesList from '../courses-list/useCoursesList';

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    ToastificationContent,
  },
  props: {
    courseData: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    const title = this.courseData.name ? (`${this.courseData.name} - Edit`) : 'Edit Course';
    return {
      title,
    };
  },
  watch: {
    courseData: function () {
      this.inheritSelects();
    },
  },
  methods: {
    inheritSelects() {
      if (this.courseData.status && !this.courseData.status.value) {
        this.courseDataInfo.status = this.statusOptions.filter((s) => s.value === this.courseData.status)[0];
      }

      if (this.courseData.visibility && !this.courseData.visibility.value) {
        this.courseDataInfo.visibility = this.visibilityOptions.filter((s) => s.value === this.courseData.visibility)[0];
      }
    },
    doSaveChanges() {
      const pwd = this.courseDataInfo;

      const pl = {
        name: pwd.name,
        visibility: pwd.visibility.value,
        status: pwd.status.value,
      };

      store
        .dispatch('app-roster/updateCourse', { courseId: pwd.id, courseData: pl })
        .then((response) => {
          this.$emit('update:course-data', response.data);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Course Edited!',
              icon: 'EditIcon',
              variant: 'success',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failed to edit course',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error.response ? error.response.data.message : error.message,
            },
          });
        });
    },
  },
  mounted() {
    this.inheritSelects();
  },
  setup(props) {
    const courseDataInfo = ref(props.courseData);

    const COURSE_APP_STORE_MODULE_NAME = 'app-roster';

    // Register module
    if (!store.hasModule(COURSE_APP_STORE_MODULE_NAME))
      store.registerModule(COURSE_APP_STORE_MODULE_NAME, rosterStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(COURSE_APP_STORE_MODULE_NAME)) store.unregisterModule(COURSE_APP_STORE_MODULE_NAME);
    });

    const { statusOptions, visibilityOptions } = useCoursesList();

    return {
      courseDataInfo,
      statusOptions,
      visibilityOptions,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
